function _(i,n,e){const t=i(7);e.isValue=function(i){return t.isPlainObject(i)&&"value"in i},e.isField=function(i){return t.isPlainObject(i)&&"field"in i}}
//# sourceMappingURL=vectorization.min.js.map